/**
 * Extract Twitch channel name from a channel name or twitch.tv URL
 * @param {string} input - Channel name or twitch.tv URL
 * @returns {string|null} Channel name or null if invalid
 */
export function extractTwitchChannelName(input) {
  if (!input || typeof input !== 'string') return null;

  const trimmed = input.trim();

  // Handle twitch.tv/channelname with or without protocol
  if (trimmed.includes('twitch.tv/')) {
    try {
      const url = trimmed.startsWith('http') ? trimmed : `https://${trimmed}`;
      const urlObj = new URL(url);
      const parts = urlObj.pathname.split('/').filter(Boolean);
      return parts[0] || null;
    } catch {
      // fall through to raw channel name
    }
  }

  // Raw channel name - strip any leading @
  return trimmed.replace(/^@/, '') || null;
}

/**
 * Validate a Twitch channel name
 * @param {string} name - Channel name to validate
 * @returns {boolean} True if valid
 */
export function isValidTwitchChannelName(name) {
  if (!name || typeof name !== 'string') return false;
  // Twitch channel names: 4-25 chars, alphanumeric and underscores only
  return /^[a-zA-Z0-9_]{1,25}$/.test(name.trim());
}

/**
 * Build a Twitch embed URL for a live channel
 * @param {string} channelName - Twitch channel name
 * @returns {string} Embed URL
 */
export function buildTwitchEmbedUrl(channelName) {
  const parent = "mogulplex.com";
  return `https://player.twitch.tv/?channel=${channelName.toLowerCase()}&parent=${parent}`;
}
